export function assignRankToGift(currentRanks = {}, giftId, value, maxRank = 1) {
  if (value === undefined || value === null || value === '') {
    const nextRanks = { ...currentRanks };
    delete nextRanks[giftId];
    return nextRanks;
  }

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue) || numericValue < 1 || numericValue > maxRank) {
    return { ...currentRanks };
  }

  const nextRanks = { ...currentRanks };
  Object.keys(nextRanks).forEach((currentGiftId) => {
    if (currentGiftId !== giftId && nextRanks[currentGiftId] === numericValue) {
      delete nextRanks[currentGiftId];
    }
  });

  nextRanks[giftId] = numericValue;
  return nextRanks;
}

export function getPersistedRankOrder(ranks = {}, maxRank = 1) {
  const entries = Object.entries(ranks).map(([giftId, rank]) => ({ giftId, rank: Number(rank) }));
  const hasInvalid = entries.some(({ rank }) => !Number.isFinite(rank) || rank < 1 || rank > maxRank);
  if (hasInvalid) {
    return null;
  }

  const duplicateRanks = new Set();
  for (const { rank } of entries) {
    if (duplicateRanks.has(rank)) {
      return null;
    }
    duplicateRanks.add(rank);
  }

  return entries
    .filter(({ rank }) => rank !== undefined && rank !== null && Number.isFinite(rank))
    .sort((a, b) => a.rank - b.rank)
    .map(({ giftId }) => giftId);
}
